import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowDashed = () => {
  return (
    <g>
      <path d="m8.9956 14.9531a.75.75 0 0 1 -.53-1.28l5.6726-5.6731-5.6729-5.6729a.75.75 0 1 1 1.0606-1.0605l6.2031 6.2034a.75.75 0 0 1 0 1.0605l-6.2031 6.2029a.7467.7467 0 0 1 -.5303.2197z" />
      <path d="m4.5386 8.75h-3.7373a.75.75 0 1 1 0-1.5h3.7373a.75.75 0 0 1 0 1.5z" />
      <path d="m11.1353 8.75h-3.7383a.75.75 0 0 1 0-1.5h3.7383a.75.75 0 0 1 0 1.5z" />
    </g>
  );
};

export default withIcon(IconArrowDashed);
